import { render, staticRenderFns } from "./PrivacyOfficeExternal.vue?vue&type=template&id=c94803bc"
import script from "./PrivacyOfficeExternal.vue?vue&type=script&lang=js"
export * from "./PrivacyOfficeExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports